import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Text,
  VStack,
  Avatar,
  HStack,
  Divider,
  Heading,
  Spinner,
  useDisclosure,
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from '@chakra-ui/react';
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';
import BrandButton from '../../../components/brandButton/BrandButton';
import IsDesktop from '../../../utils/IsDesktop';
import { useData } from '../../../data';
import RecentActivitiesTable from './RecentActivitiesTable';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Header from '../../../components/header/Header';
import moment from 'moment';
import { mutateFunction, useMutation } from '../../../libs/apis';
import { CustomToast } from '../../../components/toast/CustomToast';
import { useQueryClient } from 'react-query';
import PitchDeckModal from '../../../components/modal/PitchDeckModal';
import VideoPreviewModal from '../../../components/modal/VideoPreviewModal';

const ViewUser = () => {
  const [searchParams] = useSearchParams({});
  const userid = searchParams.get('userid');
  const isDesktop = IsDesktop();
  const { data, isLoading } = useData(`admins/users/${userid}`);
  const [userData, setUserData] = useState({});
  const [companyData, setCompanyData] = useState({});
  const [videoUrl, setVideoUrl] = useState({});
  const [pitchDeckUrl, setPitchDeckUrl] = useState({});
  const [companies, setCompanies] = useState([]);
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isDisabledToggleOpen,
    onOpen: onOpenDisabledToggle,
    onClose: onCloseDisabledToggle,
  } = useDisclosure();
  const {
    isOpen: isPitchDeckModalOpen,
    onOpen: onOpenPitchDeckModal,
    onClose: onClosePitchDeckModal,
  } = useDisclosure();
  const {
    isOpen: isVideoPreviewModalOpen,
    onOpen: onOpenVideoPreviewModal,
    onClose: onCloseVideoPreviewModal,
  } = useDisclosure();
  const cancelRef = useRef(null);
  const disableRef = useRef(null);
  const { mutate, isLoading: mutationIsLoading } = useMutation(mutateFunction);
  const { addToast } = CustomToast();

  const queryClient = useQueryClient();

  useEffect(() => {
    if (data?.data) {
      setUserData(data?.data?.user);
      setCompanyData(data?.data?.company);
      setCompanies(data?.data?.companies);
    }
  }, [data]);

  const activities = [
    {
      id: 1,
      activity_title: 'booked session with',
      interactingObject: {
        id: 1,
        title: 'Abisayo Peter Abiodun',
        image: 'https://link.to.png',
      },
      date: '01/02/2022',
    },
    {
      id: 5,
      activity_title: 'got',
      interactingObject: {
        id: 6,
        title: 'AWS',
        image: 'https://link.to.png',
      },
      date: '01/02/2022',
    },
    {
      id: 4,
      activity_title: 'Connected with',
      interactingObject: {
        id: 6,
        title: 'Lashana Lynch',
        image: 'https://link.to.png',
      },
      date: '01/02/2022',
    },
  ];

  const toggleUserBlockStatus = (e) => {
    e.stopPropagation();
    e.preventDefault();

    mutate(
      {
        key: `admins/user/${userData.id}/status`,
        method: 'put',
        data: {
          status: userData?.status === 'active' ? 'blocked' : 'active',
        },
      },
      {
        onSuccess(res) {
          addToast({
            message: `User successfully ${userData?.status === 'active' ? 'blocked' : 'unblocked'}`,
            type: 'info',
          });
          queryClient.invalidateQueries(`admins/users/${userid}`);
          onClose();
        },
      },
    );
  };

  const toggleDeletePopup = () => {
    onOpen();
  };

  const toggleUserDisabledStatus = (e) => {
    e.stopPropagation();
    e.preventDefault();

    mutate(
      {
        key: `admins/user/${userData.id}/status`,
        method: 'put',
        data: {
          status: userData?.status === 'active' ? 'disabled' : 'active',
        },
      },
      {
        onSuccess(res) {
          addToast({
            message: `User successfully ${userData?.status === 'active' ? 'disabled' : 'enabled'}`,
            type: 'info',
          });
          queryClient.invalidateQueries(`admins/users/${userid}`);
          onCloseDisabledToggle();
        },
        onError(err) {
          addToast({
            message: err?.response?.data?.message || 'Something went wrong',
            type: 'error',
          });
        },
      },
    );
  };

  const toggleFeatureStatus = (e) => {
    e.stopPropagation();
    e.preventDefault();

    mutate(
      {
        key: `admins/user/feature/${userData.id}`,
        method: 'put',
      },
      {
        onSuccess(res) {
          addToast({
            message: `${!userData?.is_featured ? 'User successfully featured' : 'Feature removed successfully'}`,
            type: 'info',
          });
          setUserData((prev) => ({
            ...prev,
            is_featured: !prev?.is_featured,
          }));
        },
      },
    );
  };

  const toggleDisablePopup = () => {
    onOpenDisabledToggle();
  };

  return (
    <Box px={5} zIndex="99">
      <Header title={'Users'} />
      <Flex
        cursor="pointer"
        my={2}
        onClick={() => navigate(-1)}
        justifyContent="flex-start"
        alignItems="center"
      >
        <Box mr={2}>
          <HiOutlineArrowNarrowLeft size="35px" />
        </Box>
        <Box>
          <Text fontWeight={600}>Back</Text>
        </Box>
      </Flex>

      {!isLoading ? (
        <div className="h-[100vh] overflow-auto hide-scroll">
          <Flex flexDirection="column" gap={4} mb={4}>
            <VStack
              mx={4}
              mb={2}
              w={{ base: '100%', md: '60%' }}
              bg="white"
              borderRadius="10px"
              boxShadow="0.5px 2px 10px lightgray"
              justifyContent="space-between"
              alignItems="flex-start"
            >
              <Flex
                h="100%"
                w="100%"
                alignItems="center"
                p={4}
                justifyContent="space-between"
              >
                <HStack
                  h="100%"
                  w="100%"
                  spacing={5}
                  justifyContent="flex-start"
                  flexDirection={{ base: 'column', md: 'row' }}
                >
                  <VStack
                    w="60%"
                    ml={2}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Box
                      p={1}
                      borderRadius="50%"
                      borderColor="lightgray"
                      borderWidth={2}
                    >
                      <Avatar
                        name={`${userData?.first_name} ${userData?.last_name}`}
                        src={userData?.profile_image}
                        size={isDesktop ? 'xl' : 'lg'}
                      />
                    </Box>
                    <Box d="flex" flexDir="column">
                      <Text
                        fontWeight={500}
                        fontSize={isDesktop ? '16px' : '12px'}
                      >
                        {`${userData?.first_name} ${userData?.last_name}`}
                      </Text>
                      <Text textAlign="center" fontWeight={300} fontSize="8px">
                        Joined{' '}
                        {moment(userData?.createdAt).format('MMM D, YYYY')}
                      </Text>
                    </Box>
                    <Flex className="gap-[3px] flex-wrap items-center justify-center">
                      <>
                        <BrandButton
                          colorScheme={
                            userData?.status === 'disabled' ? 'white' : 'blue'
                          }
                          text={
                            userData?.status !== 'disabled'
                              ? 'Disable'
                              : 'Enable'
                          }
                          width="100px"
                          onClick={toggleDisablePopup}
                        />
                        <AlertDialog
                          isOpen={isDisabledToggleOpen}
                          leastDestructiveRef={disableRef}
                          onClose={onCloseDisabledToggle}
                        >
                          <AlertDialogOverlay>
                            <AlertDialogContent>
                              <AlertDialogHeader
                                className="text-center"
                                fontSize="lg"
                                fontWeight="bold"
                              >
                                {userData?.status === 'disabled'
                                  ? 'Re-enable user'
                                  : 'Disable user'}
                              </AlertDialogHeader>

                              <AlertDialogBody>
                                Are you sure? This action cannot be undone
                                afterwards.
                              </AlertDialogBody>

                              <AlertDialogFooter>
                                <Button
                                  ref={disableRef}
                                  onClick={onCloseDisabledToggle}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  colorScheme="red"
                                  onClick={toggleUserDisabledStatus}
                                  ml={3}
                                  loading={mutationIsLoading}
                                >
                                  {userData?.status === 'disabled'
                                    ? 'Re-enable'
                                    : 'Disable'}
                                </Button>
                              </AlertDialogFooter>
                            </AlertDialogContent>
                          </AlertDialogOverlay>
                        </AlertDialog>
                      </>
                      <>
                        <BrandButton
                          colorScheme={
                            userData?.status === 'active' ? 'white' : 'blue'
                          }
                          text={
                            userData?.status !== 'blocked'
                              ? 'Delete'
                              : 'Unblock'
                          }
                          width="100px"
                          onClick={toggleDeletePopup}
                        />
                        <AlertDialog
                          isOpen={isOpen}
                          leastDestructiveRef={cancelRef}
                          onClose={onClose}
                        >
                          <AlertDialogOverlay>
                            <AlertDialogContent>
                              <AlertDialogHeader
                                className="text-center"
                                fontSize="lg"
                                fontWeight="bold"
                              >
                                {userData?.status === 'blocked'
                                  ? 'Unblock user'
                                  : 'Delete user'}
                              </AlertDialogHeader>

                              <AlertDialogBody>
                                Are you sure? This action cannot be undone
                                afterwards.
                              </AlertDialogBody>

                              <AlertDialogFooter>
                                <Button ref={cancelRef} onClick={onClose}>
                                  Cancel
                                </Button>
                                <Button
                                  colorScheme="red"
                                  onClick={toggleUserBlockStatus}
                                  ml={3}
                                >
                                  {userData?.status === 'blocked'
                                    ? 'Unblock'
                                    : 'Delete'}
                                </Button>
                              </AlertDialogFooter>
                            </AlertDialogContent>
                          </AlertDialogOverlay>
                        </AlertDialog>
                      </>
                      <>
                        <BrandButton
                          // colorScheme={
                          //   userData?.is_featured ? 'white' : 'green'
                          // }
                          text={userData?.is_featured ? 'UnFeature' : 'Feature'}
                          className={`bg-green-500`}
                          width="100px"
                          onClick={toggleFeatureStatus}
                        />
                      </>
                    </Flex>
                  </VStack>
                  <Divider orientation="vertical" />
                  <Box
                    d="flex"
                    flexDir="column"
                    justifyContent="center"
                    alignItems="center"
                    h="100%"
                    w="full"
                  >
                    <HStack spacing={16} h={7}>
                      <Text
                        w={isDesktop ? '100px' : '70px'}
                        fontSize={{ base: 12, lg: 14 }}
                        fontWeight={700}
                        color="#9FA7AD"
                      >
                        Email
                      </Text>
                      <Text
                        fontWeight={{ base: 400, '2xl': 700 }}
                        color="#000"
                        fontSize={{ base: 12, lg: 14 }}
                        align="right"
                      >
                        {userData?.email || 'N/A'}
                      </Text>
                    </HStack>
                    <HStack spacing={16} h={7}>
                      <Text
                        w={isDesktop ? '100px' : '70px'}
                        fontSize={{ base: 12, lg: 14 }}
                        fontWeight={700}
                        color="#9FA7AD"
                      >
                        Phone no.
                      </Text>
                      <Text
                        fontWeight={{ base: 400, '2xl': 700 }}
                        color="#000"
                        fontSize={{ base: 12, lg: 14 }}
                      >
                        {userData?.phone_number || 'N/A'}
                      </Text>
                    </HStack>
                    <HStack spacing={16} h={7}>
                      <Text
                        w={isDesktop ? '100px' : '70px'}
                        fontSize={{ base: 11, lg: 14 }}
                        fontWeight={700}
                        color="#9FA7AD"
                      >
                        Country
                      </Text>
                      <Text
                        fontWeight={{ base: 400, '2xl': 700 }}
                        color="#000"
                        fontSize={{ base: 12, lg: 14 }}
                      >
                        {userData?.user_type_id === 3
                          ? userData?.expert_price?.location?.title
                          : userData?.country || 'N/A'}
                      </Text>
                    </HStack>
                    <HStack spacing={16} h={7}>
                      <Text
                        w={isDesktop ? '100px' : '70px'}
                        fontSize={{ base: 11, lg: 14 }}
                        fontWeight={700}
                        color="#9FA7AD"
                      >
                        Position
                      </Text>
                      <Text
                        fontWeight={{ base: 400, '2xl': 700 }}
                        color="#000"
                        fontSize={{ base: 12, lg: 14 }}
                      >
                        {userData?.headline || 'N/A'}
                      </Text>
                    </HStack>
                    <HStack spacing={16} h={7}>
                      <Text
                        w={isDesktop ? '100px' : '70px'}
                        fontSize={{ base: 12, lg: 14 }}
                        fontWeight={700}
                        color="#9FA7AD"
                      >
                        Plan
                      </Text>
                      <Text
                        fontWeight={{ base: 400, '2xl': 700 }}
                        color="#000"
                        fontSize={{ base: 12, lg: 14 }}
                      >
                        {userData?.plan || 'N/A'}
                      </Text>
                    </HStack>
                    <HStack spacing={16} h={7}>
                      <Text
                        w={isDesktop ? '100px' : '70px'}
                        fontSize={{ base: 11, lg: 14 }}
                        fontWeight={700}
                        color="#9FA7AD"
                      >
                        Date Added
                      </Text>
                      <Text
                        fontWeight={{ base: 400, '2xl': 700 }}
                        color="#000"
                        fontSize={{ base: 12, lg: 14 }}
                      >
                        {new Date(userData?.createdAt).toLocaleString('en-US')}
                      </Text>
                    </HStack>
                    <HStack spacing={16} h={7}>
                      <Text
                        w={isDesktop ? '100px' : '70px'}
                        fontSize={{ base: 11, lg: 14 }}
                        fontWeight={700}
                        color="#9FA7AD"
                      >
                        Current Deal
                      </Text>
                      <Text
                        fontWeight={{ base: 400, '2xl': 700 }}
                        color="#000"
                        fontSize={{ base: 12, lg: 14 }}
                      >
                        {userData?.current_deal}
                      </Text>
                    </HStack>
                    <HStack spacing={16} h={7}>
                      <Text
                        w={isDesktop ? '100px' : '70px'}
                        fontSize={{ base: 11, lg: 14 }}
                        fontWeight={700}
                        color="#9FA7AD"
                      >
                        Status
                      </Text>
                      <Text
                        className="capitalize"
                        fontWeight={{ base: 400, '2xl': 700 }}
                        color="#000"
                        fontSize={{ base: 12, lg: 14 }}
                      >
                        {userData?.status}
                      </Text>
                    </HStack>
                  </Box>
                </HStack>
                {/* </Box> */}
              </Flex>
            </VStack>
            <Box flex={1} mx={4}>
              <Heading
                fontSize="16px"
                color="brand.primary"
                fontWeight={700}
                mb={2}
              >
                Linked Companies
              </Heading>
              {companies && companies.length > 0 ? (
                <Grid
                  templateColumns={['1fr', '1fr 1fr', '1fr 1fr 1fr']}
                  gap={4}
                >
                  {companies.map((company, idx) => (
                    <Box
                      key={company.id || idx}
                      bg="white"
                      borderRadius="10px"
                      boxShadow="0.5px 2px 10px lightgray"
                      p={4}
                      // transition="box-shadow 0.2s"
                      // _hover={{ boxShadow: '0 4px 20px #b3b3b3' }}
                    >
                      <HStack mb={2} spacing={3}>
                        <Avatar
                          size="md"
                          name={company.title || 'Company'}
                          src={company.logo || ''}
                        />
                        <Heading fontSize="md" color="brand.primary">
                          {company.title || 'Company'}
                        </Heading>
                      </HStack>
                      <Grid templateColumns="1fr 1fr" gap={1}>
                        <Text fontWeight={700} color="#9FA7AD" fontSize="sm">
                          Stage
                        </Text>
                        <Text>
                          {company.company_stage?.title ||
                            company.company_stage
                              ?.map((stage) => stage?.title)
                              .join(',') ||
                            'N/A'}
                        </Text>
                        <Text fontWeight={700} color="#9FA7AD" fontSize="sm">
                          Fund
                        </Text>
                        <Text>{company.fund_category?.title || 'N/A'}</Text>
                        <Text fontWeight={700} color="#9FA7AD" fontSize="sm">
                          Location
                        </Text>
                        <Text>
                          {company?.incorporation_location?.name ||
                            company?.incorporation_location
                              ?.map((loc) => loc?.name)
                              .join(',') ||
                            'N/A'}
                        </Text>
                        <Text fontWeight={700} color="#9FA7AD" fontSize="sm">
                          Model
                        </Text>
                        <Text>
                          {company.business_model?.title ||
                            company.business_model
                              ?.map((bm) => bm?.title)
                              .join(',') ||
                            'N/A'}
                        </Text>
                        <Text fontWeight={700} color="#9FA7AD" fontSize="sm">
                          Category
                        </Text>
                        <Text>
                          {company.business_category?.title ||
                            company.business_category
                              ?.map((bs) => bs?.title)
                              .join(',') ||
                            'N/A'}
                        </Text>
                        <Text fontWeight={700} color="#9FA7AD" fontSize="sm">
                          Pitch Deck
                        </Text>
                        <Box>
                          {company?.pitch_deck ? (
                              <Button
                                size="xs"
                                colorScheme="blue"
                                variant="outline"
                                onClick={() => {
                                  if(company?.pitch_deck){
                                    setPitchDeckUrl(company?.pitch_deck)
                                    onOpenPitchDeckModal()  
                                  }                                
                                }}
                              >
                                View
                              </Button>
                          ) : (
                            <Text>N/A</Text>
                          )}
                        </Box>
                        <Text fontWeight={700} color="#9FA7AD" fontSize="sm">
                          Video
                        </Text>
                        <Box>
                          {company?.video_url ? (
                              <Button
                                size="xs"
                                colorScheme="blue"
                                variant="outline"
                                onClick={() => {
                                  if(company?.video_url ){
                                    setVideoUrl(company?.video_url )
                                    onOpenVideoPreviewModal() 
                                  }                                
                                }}
                              >
                                View
                              </Button>
                          ) : (
                            <Text>N/A</Text>
                          )}
                        </Box>
                      </Grid>
                    </Box>
                  ))}
                </Grid>
              ) : (
                <Text color="gray.500">No companies linked to this user.</Text>
              )}
            </Box>
          </Flex>
          <Heading
            mt={3}
            mx={4}
            fontSize="16px"
            color="brand.primary"
            fontWeight={700}
          >
            Recent Activities
          </Heading>
          <RecentActivitiesTable user={userData} />
          <PitchDeckModal isOpen={isPitchDeckModalOpen} pitchDeckLink={pitchDeckUrl} onClose={() => {
            setPitchDeckUrl(null)
            onClosePitchDeckModal()
          }} />
          <VideoPreviewModal videoLink={videoUrl} isOpen={isVideoPreviewModalOpen} onClose={() => {
            setVideoUrl(null)
            onCloseVideoPreviewModal()
          }} />
        </div>
      ) : (
        <>
          <Spinner />
        </>
      )}
    </Box>
  );
};
export default ViewUser;
